var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2FogDay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.83 23H54a15.89 15.89 0 00-4.86-9.35A16.18 16.18 0 0022 23h-1.83a12 12 0 000 24h35.66a12 12 0 000-24zM56 43H20a8 8 0 110-16h5.68v-2a12.28 12.28 0 0124.56 0v2H56a8 8 0 010 16zm10 12a2 2 0 01-2 2H54a2 2 0 010-4h10a2 2 0 012 2zm-10.5 9a2 2 0 01-2 2h-10a2 2 0 010-4h10a2 2 0 012 2zM33 57a2 2 0 010-4h10a2 2 0 110 4H33zm1.49 7a2 2 0 01-2 2h-10a2 2 0 010-4h10a2 2 0 012.01 2h-.01zM22 57H12a2 2 0 010-4h10a2 2 0 110 4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B2_Fog_day.578bf7b0.svg";
export { SvgB2FogDay as ReactComponent };